import { render } from "./PostViewer.vue?vue&type=template&id=6e8b3857&ts=true"
import script from "./PostViewer.vue?vue&type=script&lang=ts"
export * from "./PostViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__